module.exports = "pegasus_template/assets/frame-twitter.png";